import config from "@/config";
import errors from "@/errors";

var inFlightPromise = null;
var lastFetchAt = 0;
var MIN_INTERVAL_MS = 12000;

export default {
  loading: false,
  getMenu(args, options) {
    options = options || {};
    var force = options.force === true;
    var now = Date.now();

    if (!force && inFlightPromise) {
      return inFlightPromise;
    }

    if (!force && lastFetchAt && now - lastFetchAt < MIN_INTERVAL_MS) {
      return Promise.resolve({
        success: true,
        skipped: true,
        status: "skipped",
        data: null,
        source: "MENU"
      });
    }

    const url = config.getMenuUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "MENU"
    };

    inFlightPromise = new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest && !("account_id" in args)) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (canRequest && !("session_token" in args)) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (canRequest && !("arguments" in args)) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest && !args.account_id) {
        feedback.status = errors.request.failed;
        reject(feedback);
        canRequest = false;
      }
      if (canRequest && !args.session_token) {
        feedback.status = errors.request.failed;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading = true;
        fetch(url, {
          method: "POST",
          body: JSON.stringify(args),
          headers: { "Content-Type": "application/json", "Raw-Data": "on" }
        })
          .then(res => res.text())
          .then(text => {
            var data = JSON.parse(text);

            this.loading = false;
            if (data) {
              if (typeof data.status == "string") {
                feedback.success = data.status == "1";
              } else {
                feedback.success = data.status == 1;
              }

              feedback.status = data.statusdesc;
              feedback.debug = data.debug;

              if (feedback.success == true) {
                try {
                  feedback.data = data.data;
                  resolve(feedback);
                } catch (error) {
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              reject(feedback);
            }
          })
          .catch(err => {
            this.loading = false;

            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          });
      }
    }).finally(() => {
      inFlightPromise = null;
      lastFetchAt = Date.now();
    });

    return inFlightPromise;
  }
};
